import React from 'react'
import FontAwesomeIconContainer from '../../../Components/Icons/FontAwesomeIcon'

export default function FontAwesomeIcon() {
  return (
    <div className='page-body'>
        <FontAwesomeIconContainer/>
    </div>
  )
}
